import React from 'react'
import SectionTitle from '../../components/section_title/section_title'
import Coretitle from './coreTitle/CoreTitle'
import ShowCore from './showCore/ShowCore'
import label01 from '../../assets/pic_number_a.png'
import label02 from '../../assets/pic_number_b.png'

import blue_img_a from '../../assets/blue_img_a.png'
import blue_img_b from '../../assets/blue_img_b.png'
import blue_img_c from '../../assets/blue_img_c.png'
import blue_img_d from '../../assets/blue_img_d.png'

import system_a from '../../assets/system_a.png'
import system_b from '../../assets/system_b.png'
import system_c from '../../assets/system_c.gif'

import num01 from '../../assets/icon_number_a.png'
import num02 from '../../assets/icon_number_b.png'
import num03 from '../../assets/icon_number_c.png'

import './corefunc.scss'

function CoreFunc() {
  return <div className="core_func_container">
    <SectionTitle subtitle="一站升级官网3D展销" type="black">奥本未来3D云服务３大核心功能</SectionTitle>
    <div className="section01">
      <Coretitle imglabel={label01}>为什么选择奥本未来3D云服务?</Coretitle>
      <div className="blue_container">
        <img src={blue_img_a}></img>
        <img src={blue_img_b}></img>
        <img src={blue_img_c}></img>
        <img src={blue_img_d}></img>
      </div>
    </div>
    <div className="section02">
      <Coretitle imglabel={label02}>3大核心功能</Coretitle>
      <div class="showcore_container">
        <ShowCore type="right" key={1} imguri={system_a}>
          <img src={num01}></img>
          <h2>3D数字资产后台</h2>
          <p>- <br />
                          3D资产一站式管理<br />
                          多维数据分析平台<br />
                          完备的用户管理系统<br />
          </p>
        </ShowCore>
        <div className="divider"></div>
        <ShowCore type='left' key={2} imguri={system_b}>
          <img src={num02}></img>
          <h2> 3D编辑器工具</h2>
          <p>- <br />
                        标准化模板工具<br />
                        自定义3D呈现形式<br />
                        简单易用，0基础快速上手<br />
          </p>
        </ShowCore>
        <div className="divider"></div>
        <ShowCore type='right' key={3} imguri={system_c}>
          <img src={num03}></img>
          <h2>3D渲染器</h2>
          <p>- <br />
                        全平台兼容<br />
                        适配所有主流格式<br />
          </p>
        </ShowCore>
      </div>
    </div>
  </div>
}

export default CoreFunc